"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const default_session_1 = require("../../session/default-session");
const field_dictionaries_stream_1 = require("./field-dictionaries-stream");
function Definition(params) {
    return {
        getStream(session = (0, default_session_1.getDefault)()) {
            return new field_dictionaries_stream_1.FieldDictionariesStreamImpl(session, params);
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2ZpZWxkLWRpY3Rpb25hcmllcy9kZWZpbml0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLG1FQUEyRDtBQUMzRCwyRUFBMEU7QUFJMUUsU0FBZ0IsVUFBVSxDQUFDLE1BQWlDO0lBQ3hELE9BQU87UUFDSCxTQUFTLENBQUMsVUFBbUIsSUFBQSw0QkFBVSxHQUFFO1lBQ3JDLE9BQU8sSUFBSSx1REFBMkIsQ0FBQyxPQUFPLEVBQUUsTUFBTSxDQUFDLENBQUM7UUFDNUQsQ0FBQztLQUNKLENBQUM7QUFDTixDQUFDO0FBTkQsZ0NBTUMifQ==